import { BillingTransferRequest } from "@common/dto/billing/transfer-request.dto";
import {
    BillingTransferRequestStatus,
    getBillingTransferRequestResolutionUrl,
} from "@common/constants/domains/billing/billingTransferRequest";

export function useBillingTransferUrls(
    transferRequest: BillingTransferRequest,
) {
    return {
        acceptTransferRequest: getBillingTransferRequestResolutionUrl(
            transferRequest,
            BillingTransferRequestStatus.ACCEPTED,
        ),
        rejectTransferRequest: getBillingTransferRequestResolutionUrl(
            transferRequest,
            BillingTransferRequestStatus.REJECTED,
        ),
    };
}
